import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../../config/config";
import { getToken } from "../../../utils/localStorageMethods";

export const rideshareBaseApi = createApi({
  reducerPath: "rideshareApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.RideshareUrl,
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["RideshareDrivers", "RideshareVehicles", "RideshareRides", "RideshareCustomers", "RidesharePayments"],
  endpoints: () => ({}),
});
